import { render } from "./WrongRequest.vue?vue&type=template&id=6726f686&scoped=true"
const script = {}

import "./WrongRequest.vue?vue&type=style&index=0&id=6726f686&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6726f686"]])

export default __exports__